define(function (require) {
    var $ = require("jquery");

    $(document).ready(function () {
        var featuredCTAs = $('div.featured-cta-modal');

        featuredCTAs.each(function (index, value) {
            var featuredCTA = $(value);
            var isTwoColumnCTA = (featuredCTA.find('.IsCTA1Modal') || featuredCTA.find('.IsCTA2Modal'));
            var isOneColumnCTA = featuredCTA.find('.IsCTAModal');

            var isOnHero = featuredCTA.find('.IsOnHero').val() === "True";

            var modalMarkup =
                "<div class=\"modal fade\" id=\"{0}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"{1}\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" style=\"float:right;border:none;background:none;\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">{3}</h4></div><div class=\"modal-body\"><div class=\"embed-responsive embed-responsive-16by9\"><iframe width=\"560\" height=\"315\" src=\"{2}\" frameborder=\"0\" allowfullscreen></iframe></div></div></div></div></div>";

            if (isTwoColumnCTA) {
                var isCTA1Modal = featuredCTA.find('.IsCTA1Modal').val();
                var isCTA2Modal = featuredCTA.find('.IsCTA2Modal').val();

                if (isCTA1Modal) {
                    var CTA1ID = featuredCTA.find('.CTA1ModalID').val();
                    var CTA1Label = CTA1ID + "label";
                    var CTA1URL = featuredCTA.find('.CTALinkColumn1_Url').val();
                    var CTA1ModalTitle = featuredCTA.find('.CTA1ModalTitle').val();
                    var modal1Markup = modalMarkup.replace("{0}", CTA1ID).replace("{1}", CTA1Label).replace("{2}", CTA1URL).replace("{3}", CTA1ModalTitle);

                    if (isOnHero) {
                        var heroImage = featuredCTA.parent().parent().parent().find('div.hero-img');
                        $(modal1Markup).insertBefore(heroImage);
                    } else {
                        $(modal1Markup).appendTo('body');
                    }

                    if (window.ytTracker != null) {
                        window.ytTracker.digestPotentialVideos(featuredCTA.parent().parent().parent().find('div#' + CTA1ID).find('iframe'));
                    }
                }

                if (isCTA2Modal) {
                    var CTA2ID = featuredCTA.find('.CTA2ModalID').val();
                    var CTA2Label = CTA2ID + "label";
                    var CTA2URL = featuredCTA.find('.CTALinkColumn2_Url').val();
                    var CTA2ModalTitle = featuredCTA.find('.CTA2ModalTitle').val();
                    var modal2Markup = modalMarkup.replace("{0}", CTA2ID).replace("{1}", CTA2Label).replace("{2}", CTA2URL).replace("{3}", CTA2ModalTitle);

                    if (isOnHero) {
                        var heroImage = featuredCTA.parent().parent().parent().find('div.hero-img');
                        $(modal2Markup).insertBefore(heroImage);
                    } else {
                        $(modal2Markup).appendTo('body');
                    }
                    if (window.ytTracker != null) {
                        window.ytTracker.digestPotentialVideos(featuredCTA.parent().parent().parent().find('div#' + CTA2ID).find('iframe'));
                    }
                }
            }

            if (isOneColumnCTA) {
                var isCTAModal = featuredCTA.find('.IsCTAModal').val();

                if (isCTAModal) {
                    var CTAID = featuredCTA.find('.CTAModalID').val();
                    var CTALabel = CTAID + "label";
                    var CTAURL = featuredCTA.find('.CTALink_Url').val();
                    var CTAModalTitle = featuredCTA.find('.CTAModalTitle').val();
                    var ctaModalMarkup = modalMarkup.replace("{0}", CTAID).replace("{1}", CTALabel).replace("{2}", CTAURL).replace("{3}", CTAModalTitle);
                    var ctaLink = featuredCTA.find('a#' + CTALabel);

                    $(ctaModalMarkup).insertAfter(ctaLink);
                    if (window.ytTracker != null) {
                        window.ytTracker.digestPotentialVideos(featuredCTA.parent().parent().parent().find('div#' + CTAID).find('iframe'));
                    }
                }
            }

        });
    });
});
